import { LoginPage } from './../../pages/login';

export const LogInView = () => {
  return (
    <>
      <LoginPage />
    </>
  );
};
